<template>
  <div>
    <p class="xPadding titleModal">
      {{ $t(`technicalFile.closedLoop.step0.title`) }}
    </p>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VTextField
          v-model="data.name"
          class="text-field-transparent"
          :label="$t('technicalFile.closedLoop.step0.identifier')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VSelect
          v-model="data.type"
          outlined
          :readonly="readonly"
          :label="$t('technicalFile.closedLoop.step0.type')"
          itemValue="key"
          itemText="name"
          :items="displayedUnits('systemType')"
          @input="updateData"
        />
      </v-col>
      <v-col class="py-0">
        <VSelect
          v-model="data.operation"
          outlined
          :readonly="readonly"
          :label="$t('technicalFile.closedLoop.step0.operation')"
          itemValue="key"
          itemText="name"
          :items="displayedUnits('closedLoopOperation')"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VSelect
          v-model="data.fluid"
          outlined
          :readonly="readonly"
          :label="$t('technicalFile.closedLoop.step0.fluid')"
          itemValue="key"
          itemText="name"
          :items="displayedUnits('fluid')"
          @input="updateData"
        />
      </v-col>
      <v-col
        v-if="data.fluid === 5"
        class="py-0"
      >
        <VTextField
          v-model="data.otherFluid"
          class="text-field-transparent"
          :label="$t('technicalFile.closedLoop.step0.name')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VTextField
          v-model="data.operatingTemperature.value"
          class="text-field-transparent"
          :label="$t('technicalFile.closedLoop.step0.operatingTemperature')"
          outlined
          :readonly="readonly"
          type="number"
          min="0"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col class="py-0">
        <VSelect
          v-model="data.operatingTemperature.units"
          outlined
          :readonly="readonly"
          :label="$t('technicalFile.closedLoop.step0.unit')"
          itemValue="key"
          itemText="name"
          :items="displayedUnits('operatingTemperature')"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VTextField
          v-model="data.volume.value"
          class="text-field-transparent"
          :label="$t('technicalFile.closedLoop.step0.volume')"
          outlined
          :readonly="readonly"
          type="number"
          min="0"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col class="py-0">
        <VSelect
          v-model="data.volume.units"
          outlined
          :readonly="readonly"
          :label="$t('technicalFile.closedLoop.step0.unit')"
          itemValue="key"
          itemText="name"
          :items="displayedUnits('loopCapacity')"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VTextField
          v-model="data.averageMakeup.value"
          class="text-field-transparent"
          :label="$t('technicalFile.closedLoop.step0.makeup')"
          outlined
          :readonly="readonly"
          type="number"
          min="0"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col class="py-0">
        <VSelect
          v-model="data.averageMakeup.units"
          outlined
          :readonly="readonly"
          :label="$t('technicalFile.closedLoop.step0.unit')"
          itemValue="key"
          itemText="name"
          :items="displayedUnits('makeUp')"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VTextField
          v-model="data.maximumPressure.value"
          class="text-field-transparent"
          :label="$t('technicalFile.closedLoop.step0.maxPressure')"
          outlined
          :readonly="readonly"
          type="number"
          min="0"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col class="py-0">
        <VSelect
          v-model="data.maximumPressure.units"
          outlined
          :readonly="readonly"
          :label="$t('technicalFile.closedLoop.step0.unit')"
          itemValue="key"
          itemText="name"
          :items="displayedUnits('pressure')"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VSelect
          v-model="data.metallurgy"
          outlined
          :readonly="readonly"
          :label="$t('technicalFile.closedLoop.step0.metallurgy')"
          itemValue="key"
          itemText="name"
          :items="displayedUnits('closedLoopMetallurgy')"
          @input="updateData"
        />
      </v-col>
      <v-col
        v-if="data.metallurgy === 5"
        class="py-0"
      >
        <VTextField
          v-model="data.otherMetallurgy"
          class="text-field-transparent"
          :label="$t('technicalFile.closedLoop.step0.name')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';

export default {
    name: 'System',
    components: {
        VTextField,
    },
    props: {
        system: {
            type: Object,
            default: () => {},
        },
        parentNode: {
            type: String,
            default: () => '',
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            otherMetallurgy: '',
            data: {
                operatingTemperature: {},
                volume: {},
                averageMakeup: {},
                maximumPressure: {},
            },
            isEditabled: false,
        };
    },
    computed: {
        ...mapGetters([
            'units',
        ]),
    },
    watch: {
        system: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.system) };
            },
            immediate: true,
        },
    },
    methods: {
        displayedUnits(type) {
            return this.units && this.units[type] ? this.units[type] : [];
        },
        updateData() {
            this.$emit('sendData', { system: this.data });
        },
    },
};
</script>
<style lang="scss" scoped>
 .file-container {
    display: flex;
    padding: 0;
 }
 .xPadding{
  padding: 0 6rem;
}
.image a {
    text-decoration: underline;
}
.add-btn{
  margin-top: -30px;
}
@media screen and (max-width: 600px) {
   .xPadding{
      padding: 0;
    }
}
</style>
